import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, NavParams } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EMAIL_PATTERN, PASSWORD_PATTERN, emailMatchValidator, mustBeTruthy } from 'src/app/services/customFormValidators';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { ILoginRequestData } from 'src/app/interfaces/authentication.interface';
import { OverlayService } from 'src/app/services/overlay/overlay.service';

@Component({
  selector: 'app-apply-boyd-rewards-step-one',
  templateUrl: './apply-boyd-rewards-step-one.component.html',
  styleUrls: ['./apply-boyd-rewards-step-one.component.scss'],
})
export class ApplyBoydRewardsStepOneComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  public connectBoydCardPath: boolean = false;
  public termsSingupLinkTitle;
  public bonusCode;
  public stateName: string = this.configService.getState() ?? 'Stardust';
  public error = null;
  public infoForm: FormGroup;
  public emailGroup: AbstractControl;
  public email: AbstractControl;
  public emailConfirm: AbstractControl;
  public password: AbstractControl;
  public passwordConfirm: AbstractControl;
  public certOver18: AbstractControl;
  public agreeAllTC: AbstractControl;
  public csrf_token: string = '';
  public registrationSuccessful: boolean = false;
  public buttonDisabled: boolean = false;
  public bonusIsVerified: boolean = false;
  public selectedBonusIndex;
  public showPassword: boolean;
  public showConfirmPassword: boolean;
  public customerAttributionData: any[];
  public extAffiliateId: string;
  public verifiedInputBonusCode: string;
  public welcomeOffers = [];
  public allowPromoEmailsCheck: boolean;
  public behalfSignupCheck: boolean;
  public allowPromoEmails: AbstractControl;
  public behalf: AbstractControl;
  public legalAge: number;
  public agreementProcess: boolean = true;
  public agreedCondition: boolean = false;
  private termsSingupLinkCode;
  isPlayerLoggedInAsGuest: boolean = false;
  isPlayerFirstVisit;
  public customer: CustomerModel;
  public featureTermsAndConditionURL: string;
  public featurePrivacyURL: string;

  constructor(
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private navigator: Navigator,
    private successMessageService: SuccessMessageService,
    private appLinks: AppLinksService,
    private overlayService: OverlayService,
    private userSessionService: UserSessionService,
    private appStorageService: AppstorageTsService,
    private navParams: NavParams
  ) { }

  ngOnInit() {
    this.appStorageService.getPlayerAsGuest().then((isGuest) => {
      if (isGuest.value === 'true') return this.isPlayerLoggedInAsGuest = true;
      return this.isPlayerLoggedInAsGuest = false;
    })

    this.resetWelcomeDialog();

    this.userSessionService.getCustomer().subscribe((customer) => {
      if (customer) {
        this.customer = customer;
      }
    });
    this.connectBoydCardPath = this.navParams.data.connectBoydCardPath;
    this.legalAge = this.configService.getConfig().FEATURE_LEGAL_AGE ?? 21;
    this.allowPromoEmailsCheck = this.configService.getConfig().FEATURE_SIGNUP_SHOW_PROMO_FIELD === '1' ? true : false;
    this.behalfSignupCheck = this.configService.getConfig().FEATURE_SIGNUP_SHOW_BEHALF_FIELD === '1' ? true : false;
    this.infoForm = new FormGroup({
      clientapp: new FormControl(''),
      emailGroup: new FormGroup({
        email: new FormControl('', [Validators.pattern(EMAIL_PATTERN), Validators.required, Validators.maxLength(250)]),
      }),
      password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
      csrf: new FormControl(),
      certOver18: new FormControl(false, [mustBeTruthy]),

    }
    );

    this.infoForm.get("clientapp").setValue(this.configService.getClientApp());

    this.emailGroup = this.infoForm.get('emailGroup');
    this.email = this.emailGroup.get('email');
    this.emailConfirm = this.emailGroup.get('emailConfirm');

    this.password = this.infoForm.get('password');

    this.certOver18 = this.infoForm.get('certOver18');
    this.featureTermsAndConditionURL = this.configService.getConfig().FEATURE_SITE_TERMS_LINK;
    this.featurePrivacyURL = this.configService.getConfig().FEATURE_SITE_PRIVACY_LINK;

  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.authenticationService.getCsrfToken().subscribe((response) => {
      if (!!response.payload && !!response.payload.token) {
        this.csrf_token = response.payload.token;
      }
    });
  }

  async resetWelcomeDialog(){
    this.isPlayerFirstVisit = (await this.appStorageService.getPlayerFirstVisit()).value;
    if (this.isPlayerFirstVisit === 'true' && !this.isPlayerLoggedInAsGuest) {
     this.overlayService.hide();
    }
  }

  public onSubmit() {

    let applyBoydRewardsPlayerData: any = {
      email: this.emailGroup.value["email"],
      password: this.infoForm.value["password"],
      csrf: this.csrf_token
    }

    if (this.isPlayerLoggedInAsGuest) {
      //user is already have guest account then call update-account webservice 
      this.authenticationService.callApplyForBoydRewardsStep1(applyBoydRewardsPlayerData).subscribe(
        (response) => {
          if (response && !!response.result) {
            this.userSessionService.refreshCustomer();
            this.navigator.navigateTo('ApplyBoydRewardsStepTwoComponent', { customModalClass: 'crown-modal' })
          }
        },
        (error) => {
          this.buttonDisabled = false;
          this.generateCsrfToken();
          console.error("callApplyForBoydRewardsStep1 error = ", error);
          this.content.scrollToTop(10);
          this.handleError(error)
          this.error = error;
        }
      )

    } else {
      //user don't have any information and choose to singup with Email option and also don't have boyd reward card information 
      //call signup-step1 webservice
      this.authenticationService.callSignupStep1(applyBoydRewardsPlayerData).subscribe(
        (response) => {
          if (response && !!response.result) {
            if (response.result == 1) {
              //this.userSessionService.refreshCustomer();
              const customer_id = response.payload.customerId;
              const csrf_token = (response.payload.csrf_token) ? response.payload.csrf_token : 'override';
              const step1Info: ILoginRequestData = { csrf: csrf_token, username: this.emailGroup.value["email"], password: this.infoForm.value["password"], clientapp: this.configService.getClientApp() };
              if (!isUndefined(response.payload.platformId)) this.appStorageService.setPlayerPlatformID(response.payload.platformId);
              this.authenticationService.callLogin(step1Info).subscribe(
                (response) => {
                  if (response && !!response.result) {
                    this.userSessionService.setSessionToken(response.payload.sessionToken);
                    if (!isUndefined(response.payload.customerId)) {
                      this.userSessionService.setCustomerId(response.payload.customerId);
                      this.userSessionService.setUserStatus({
                        customerId: response.payload.customerId,
                        sessionToken: response.payload.sessionToken
                      })
                    }
                    this.userSessionService.refreshCustomer().subscribe(() => {
                      this.navigator.navigateTo('ApplyBoydRewardsStepTwoComponent', { customModalClass: 'crown-modal' })
                    });
                  }
                },
                (error) => {
                  this.generateCsrfToken();
                  switch (error.getErrorCode().toUpperCase()) {
                    case 'CUSTOMER_SUSPENDED':
                      error.setErrorMessage('Your account has been temporarily suspended. Please contact support.');
                      break;
                  }
                  this.error = error;
                  this.content.scrollToTop(10);
                }
              );
            }

          }
        },
        (error) => {
          this.buttonDisabled = false;
          this.generateCsrfToken();
          console.error("callApplyForBoydRewardsStep1 error = ", error);
          this.content.scrollToTop(10);
          this.handleError(error)
          this.error = error;
        }
      )
    }
  }

  handleError(error: any) {
    switch (error.getErrorCode().toUpperCase()) {
      case 'EMAIL_ALREADY_EXISTS':
        error.setErrorMessage('Form has errors, please see below.');
        this.email.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
        //this.emailConfirm.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
        this.emailGroup.setErrors({ 'EMAIL_ALREADY_EXISTS': true });
        this.emailGroup.markAsTouched();
        this.emailGroup.markAsDirty();
        break;
      case 'ALREADY_HAS_ACCOUNT':
        error.setErrorMessage('It appears this account has already been created.');
        break;
      case 'CUSTOMER_IN_BLACKLIST':
        error.setErrorMessage('Cannot create account please contact customer support.');
        break;
      case 'GOVERNMENT_ID_ALREADY_EXISTS':
        error.setErrorMessage('Cannot create account please verify your data. Contact support if the issue continues.');
        break;
      default:
        error.setErrorMessage("Something went wrong. Please try again or contact customer support.");
        break;
    }
  }

  generateCsrfToken() {
    this.authenticationService.getCsrfToken().subscribe(
      (response) => {
        if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
          this.csrf_token = response.payload.token;
        }
      }
    );
  }

  protected goToLink(url: string): any {
    return this.appLinks.openExternalPage(url);
  }

  protected hidePassword(): boolean {
    this.showPassword = false;
    return;
  }

  protected unhidePassword(): boolean {
    this.showPassword = true;
    return;
  }

  protected hideConfirmPassword(): boolean {
    this.showConfirmPassword = false;
    return;
  }

  protected unhideConfirmPassword(): boolean {
    this.showConfirmPassword = true;
    return;
  }


}
